import '@styles/webdesktop/stylesheets/updateNotificationScreen.scss';
import React from 'react';
import { Stack } from '../../elements/Stack/Stack';
import { Spacing } from '@front/sharedcomponents/Variables';
import { TypographyLevel } from '../../elements/Typography/TypographyLevel';
import { Button } from '../../elements/Button/Button';
import { ButtonType } from '../../elements/Button/ButtonType';
import { Label } from '../../elements/Label/Label';
import { useLocalize } from '../../hooks/useLocalize';
export const UpdateNotificationScreen = ({ onLaterButtonClick, isForceUpdate }) => {
    const [content, laterButtonText, updateButtonText] = useLocalize(isForceUpdate ? 'screen.updateNotification.forceContent' : 'screen.updateNotification.content', 'screen.updateNotification.laterButtonText', 'screen.updateNotification.updateButtonText');
    return (React.createElement(Stack, { direction: "column", spacing: Spacing.Large },
        React.createElement(Label, { level: TypographyLevel.Paragraph }, content),
        React.createElement(Stack, { className: "update-notification-screen-buttons", direction: "row", spacing: Spacing.Medium, justify: "flex-end" },
            React.createElement(Button, { type: ButtonType.Primary, text: updateButtonText, onClick: () => globalThis.location.reload() }),
            !isForceUpdate && (React.createElement(Button, { type: ButtonType.Secondary, text: laterButtonText, onClick: onLaterButtonClick })))));
};
